<template>
  <v-container colum>
    <h2 class="subtitle">
        Agenda
    </h2>
    <v-row>
        <v-col cols=12>
            <v-card>
                <agenda />
            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Agenda from "@components/agenda/Agenda"
export default {
  components: {
    Agenda
  },
  data: () => ({
    messages: [],
  }),
  mounted(){
  },

}
</script>

<style>

</style>